<template>
    <toolbar-option>
        <template slot="primary">
            <input
                v-model="value"
                type="text"
                placeholder="Add aria-label value"
                @change="setChangedData(true)"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'aria-label',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'aria-label',
            value: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].ariaLabelNew = this.value;
            this.onOptionChange(this.value);
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].ariaLabelNew;
        },
    },
};
</script>
